var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5a1 1 0 0 1 1-1h6.671c.456 0 1.093.264 1.415.586l6.328 6.328a2 2 0 0 1 0 2.829l-5.671 5.671a2 2 0 0 1-2.828 0l-6.329-6.328C4.264 12.764 4 12.129 4 11.67zm2.857 3a1.143 1.143 0 1 0 2.286 0 1.143 1.143 0 0 0-2.286 0"
  })));
};
export default SvgTag;